export var GLOBAL = {
  url: 'https://sistemaperiodistas.com/crm_api/public/api/'
}

export var GLOBAL_IMAGES = {
  url: 'https://sistemaperiodistas.com/crm_api/public/avatar/'
}

export var GLOBAL_DOCS = {
  url: 'https://sistemaperiodistas.com/crm_api/public/doc/'
}
//  url: 'https://sistemaperiodistas.com/crm_api/public/api/'
